import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e32c0f5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-layout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-nav" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "nav-title" }, "進貨管理系統")
], -1))
const _hoisted_3 = { class: "mobile-container" }
const _hoisted_4 = { class: "mobile-card-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-left" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header-title" }, "進貨辨識照片上傳"),
  /*#__PURE__*/_createElementVNode("p", { class: "header-subtitle" }, "請連續上傳單據或貨品影像")
], -1))
const _hoisted_6 = {
  key: 0,
  class: "header-right"
}
const _hoisted_7 = { class: "mobile-form" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "進貨日期", -1))
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-label" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 上傳圖片 ")
const _hoisted_13 = {
  key: 0,
  class: "label-hint"
}
const _hoisted_14 = {
  key: 1,
  class: "label-hint-uploading"
}
const _hoisted_15 = { class: "upload-content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-text" }, "點擊拍攝或選取照片", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-hint" }, "上傳後可立即傳下一張", -1))
const _hoisted_18 = {
  key: 1,
  class: "upload-loading-text"
}
const _hoisted_19 = {
  key: 0,
  class: "uploaded-gallery"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gallery-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "gallery-title" }, "剛上傳的紀錄")
], -1))
const _hoisted_21 = { class: "gallery-badge" }
const _hoisted_22 = { class: "gallery-time" }
const _hoisted_23 = { class: "switch-view-container" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 前往完整版網頁 → ")

import { uploadImage as uploadImageUtil } from "@/util/globle-method"
import { Check, UploadFilled } from '@element-plus/icons-vue'
import { ElMessage, type UploadRequestOptions } from 'element-plus'
import { ref } from "vue"

interface UploadedItem {
  id: string;
  url: string;
  time: string;
  status: 'success' | 'warning';
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  emits: ['switchToDesktop'],
  setup(__props) {



const selectedDate = ref(new Date().toISOString().split("T")[0])
const isUploading = ref(false)
const uploadedList = ref<UploadedItem[]>([])

const uploadImage = async (file: File): Promise<string> => {
  const res = await uploadImageUtil(file)
  return res
}

const customUploadRequest = async (options: UploadRequestOptions) => {
  const { file } = options

  if (!selectedDate.value) {
    ElMessage.warning("請先選擇日期")
    return
  }

  isUploading.value = true

  try {
    const imageUrl = await uploadImage(file)

    const res = await fetch(`${process.env.VUE_APP_APIURL}/api/v1/purchase/upload`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        imageUrl: imageUrl,
        purchaseDate: selectedDate.value,
      }),
    })

    if (!res.ok) throw new Error("Submission failed")

    const result = await res.json()

    const now = new Date()
    const timeString = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`

    uploadedList.value.unshift({
      id: result.dbId || Date.now().toString(),
      url: imageUrl,
      time: timeString,
      status: result.status,
      data: result.lines?.[0]
    })

    if (result.status === 'warning') {
      ElMessage.warning("上傳成功，但部分內容辨識不完全")
    } else {
      ElMessage.success("辨識並存檔完成")
    }
  } catch (error) {
    console.error(error)
    ElMessage.error("上傳失敗，請重試")
  } finally {
    isUploading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_card, {
        class: "mobile-card",
        shadow: "never"
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (uploadedList.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_el_date_picker, {
                modelValue: selectedDate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
                type: "date",
                placeholder: "請選擇日期",
                format: "YYYY/MM/DD",
                "value-format": "YYYY-MM-DD",
                class: "mobile-date-picker",
                size: "large",
                editable: false
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, [
                _hoisted_12,
                (!isUploading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "(支援點擊或拖曳)"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_14, "正在上傳中..."))
              ]),
              _createVNode(_component_el_upload, {
                class: _normalizeClass(["mobile-uploader", { 'is-loading': isUploading.value }]),
                drag: "",
                action: "#",
                "http-request": customUploadRequest,
                "show-file-list": false,
                accept: "image/*",
                disabled: isUploading.value
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (!isUploading.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_el_icon, { class: "upload-icon" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(UploadFilled))
                            ]),
                            _: 1
                          }),
                          _hoisted_16,
                          _hoisted_17
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, "影像處理中..."))
                  ])), [
                    [_directive_loading, isUploading.value]
                  ])
                ]),
                _: 1
              }, 8, ["class", "disabled"])
            ]),
            (uploadedList.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_TransitionGroup, {
                    name: "list",
                    tag: "div",
                    class: "gallery-grid"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedList.value, (img) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: img.id,
                          class: "gallery-item"
                        }, [
                          _createVNode(_component_el_image, {
                            src: img.url,
                            fit: "cover",
                            class: "gallery-image",
                            "preview-src-list": [img.url],
                            "preview-teleported": ""
                          }, null, 8, ["src", "preview-src-list"]),
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Check))
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_22, _toDisplayString(img.time), 1)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('switchToDesktop')))
        }, {
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})